/* eslint-disable no-redeclare */
import { z } from 'zod';

export const Name = z
  .string()
  .min(1)
  .regex(/^[^\d\s]+(\s*)$/)
  .transform((value) => value.trim())
  .transform((value) => value.charAt(0).toUpperCase() + value.slice(1));

export type Name = z.infer<typeof Name>;
